import type { AddNotificationPayload } from '../redux/notificationsSlice';

export type PushContent = {
  messageId?: string | null;
  title?: string | null;
  body?: string | null;
  data?: Record<string, any> | null;
};

const readString = (value: unknown): string =>
  typeof value === 'string' ? value.trim() : '';

/**
 * The inbox item for a push. A notice the server stored carries its id and
 * location, so the copy fetched later replaces this one instead of
 * duplicating it. Null when there is nothing to show.
 */
export function notificationFromPush({
  messageId,
  title,
  body,
  data,
}: PushContent): AddNotificationPayload | null {
  const cleanTitle = readString(title);
  const cleanBody = readString(body);
  if (!cleanTitle && !cleanBody) return null;

  const payload = data && typeof data === 'object' ? data : {};
  const notificationId = readString(payload.notificationId);
  const locationId = readString(payload.locationId);
  const type = readString(payload.type);

  return {
    id: notificationId || readString(messageId) || undefined,
    title: cleanTitle || 'Notification',
    body: cleanBody,
    source: 'push',
    data: payload,
    locationId: locationId || undefined,
    type: type || undefined,
  };
}
